import { API_REQUEST } from '../../core/actions';
import * as utilitiesAPI from '../../core/api/utilities';
import * as utilityUnitsAPI from '../../core/api/utility-units';
import { SortDirection } from '../../core/components/DataTableHeaders';
import * as utils from '../../core/utils';
import { get, isNil } from 'lodash';

export const FETCH_UTILITY_UNITS = 'FETCH_UTILITY_UNITS';
export const FETCH_UTILITIES = 'FETCH_UTILITIES';
export const GET_UTILITY = 'GET_UTILITY';
export const ADD_UTILITY = 'ADD_UTILITY';
export const SAVE_UTILITY = 'SAVE_UTILITY';
export const DELETE_UTILITY = 'DELETE_UTILITY';
export const SET_CURRENT_UTILITY = 'SET_CURRENT_UTILITY';

export const fetchUtilityUnits = () => ({
  type: API_REQUEST,
  callAPI: utilityUnitsAPI.fetchUtilityUnits,
  data: {},
  action: FETCH_UTILITY_UNITS,
});

export const fetchUtilities = (params) => {
  const sortQuery = {
    key: 'id',
    direction: utils.toString(SortDirection, SortDirection.DESC),
  };
  if (get(params, 'sortQuery', false)) {
    const key = get(params.sortQuery, 'key');
    const sortDirection = get(params.sortQuery, 'direction');

    if (key) {
      sortQuery.key = key;
    }
    if (!isNil(sortDirection)) {
      sortQuery.direction = utils.toString(SortDirection, sortDirection);
    }
  }
  return {
    type: API_REQUEST,
    callAPI: utilitiesAPI.fetchUtilities,
    data: {
      query: {
        types:
          params && params.currentFilters && params.currentFilters.utilityType
            ? params.currentFilters.utilityType
            : '',
        page: (params && params.page) || 0,
      },
    },
    action: FETCH_UTILITIES,
  };
};

export const getUtility = (id) => ({
  type: API_REQUEST,
  callAPI: utilitiesAPI.getUtility,
  data: { id },
  action: GET_UTILITY,
});

export const addUtility = (utility) => ({
  type: API_REQUEST,
  callAPI: utilitiesAPI.postUtility,
  data: utility.data,
  action: ADD_UTILITY,
  callback: utility.callback,
  closeModal: true,
});

export const saveUtility = (utility) => ({
  type: API_REQUEST,
  callAPI: utilitiesAPI.patchUtility,
  data: utility.data,
  action: SAVE_UTILITY,
  callback: utility.callback,
  closeModal: true,
});

export const deleteUtility = (id, callback) => ({
  type: API_REQUEST,
  callAPI: utilitiesAPI.deleteUtility,
  data: { id },
  action: DELETE_UTILITY,
  callback: callback,
  closeModal: true,
});

export const setSelectedUtility = (utility) => ({ type: SET_CURRENT_UTILITY, utility });
